import {entities} from '../../../../../util/uiconstants';
import _ from 'lodash';

const mapResponse = {
	Scot: (response) => {
		if (response) {
			return response.data.map((entity) => {
				return {
					name: entity.name,
					entityId: entity.entityId,
					id: entity.id,
					documentEntityId: entity.documentEntityId,
					parentEntityUId: Number(entity.entityUId),
					parentEntityId: entity.parentEntityId,
					formSectionRelatedObjectId: entity.formSectionRelatedObjectId,
					parentFormSectionRelatedObjectId: entity.parentFormSectionRelatedObjectId
				};
			});
		}
	},

	WcgwsControls: (response) => {
		if (response && response.wcgWs) {
			let wcgws = _.compact(
				response.wcgWs.map((wcgw) => {
					return {
						name: wcgw.wcgwName,
						entityId: entities.WCGW,
						id: wcgw.id,
						parentEntityUId: response.id,
						parentEntityId: entities.SCOT
					};
				})
			);
			if (wcgws) {
				if (response.controls && response.controls.length > 0) {
					wcgws.map((wcgw) => {
						wcgw.children = [];
						let myControls = response.controls.filter((control) => control.wcgwId === wcgw.id);
						if (myControls) {
							myControls.map((c) => {
								wcgw.children.push({
									name: c.controlName,
									entityId: entities.Control,
									id: c.id,
									parentEntityUId: wcgw.id,
									parentEntityId: entities.WCGW
								});
							});
						}
					});
				}
			}
			return wcgws;
		}
	},

	EngagementRisks: (response, engagementId) => {
		if (response) {
			return response.data.map((entity) => {
				return {
					name: entity.riskName,
					entityId: entities.Risk,
					id: entity.id,
					abbrevation: entity.riskAbbreviation,
					riskTypeId: entity.riskTypeId,
					parentEntityId: entities.Engagement,
					parentEntityUId: engagementId
				};
			});
		}
	},

	Control: (response) => {
		if (response) {
			return response.data.map((entity) => {
				return {
					name: entity.name,
					entityId: entity.entityId,
					id: entity.id,
					documentEntityId: entity.documentEntityId,
					parentEntityUId: Number(entity.entityUId),
					parentEntityId: entity.parentEntityId,
					formSectionRelatedObjectId: entity.documentRelatedObjectId
				};
			});
		}
	},

	ITAPPSO: (response) => {
		if (response) {
			return response.itApplications.map((entity) => {
				return {
					name: entity.itApplicationName,
					entityId: entities.ItSoApplication,
					id: entity.id,
					parentEntityUId: response.id,
					parentEntityId: entities.Control
				};
			});
		}
	}
};

export default mapResponse;
